module.exports = __webpack_public_path__ + "img/details5.8c76517a.png";